import React, { useEffect, useState } from 'react';

import './Navigation.scss';

interface INavigationProps {
  items: {
    label: string;
    anchor: React.RefObject<HTMLElement>;
  }[];
}

export const Navigation = ({ items }: INavigationProps) => {
  const [open, setOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + 110;
      let foundIndex: number | null = null;

      items.forEach((item, index) => {
        if (item.anchor.current) {
          const elementTop = item.anchor.current.offsetTop;
          if (scrollPosition >= elementTop) {
            foundIndex = index;
          }
        }
      });

      setActiveIndex(foundIndex);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [items]);

  return (
    <div className={'health-report-navigation-container' + (open ? ' open' : '')}>
      <div className="navigation" onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
        {items.map((item, index) => (
          <button
            key={item.label}
            className="navigation-item"
            onClick={() => {
              window.scrollTo({ top: (item.anchor.current?.offsetTop ?? 0) - 100, behavior: 'smooth' });
            }}
          >
            <div className={'navigation-dot' + (activeIndex === index ? ' active' : '')} />
            <p className="navigation-label">{item.label}</p>
          </button>
        ))}
      </div>
    </div>
  );
};

export default Navigation;
